export default __webpack_public_path__ + "static/media/602.8ef9bcb9.png";